import makeStyles  from '@mui/styles/makeStyles';

let useStyles;
export default useStyles = makeStyles({
    btn: {
        backgroundColor: 'black',
        color: 'white',
        '&:hover': {
            backgroundColor: 'white',
            color: 'black'
        }
    },

})

